import React from 'react';
import { SummaryType } from '@ls/grouping-service';
import { titleCase } from '@ls/js-utils';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_DEFINITION } from './actions';
import CalcType from 'state/Constants/CalcType';
import ScaleType from 'state/Constants/ScaleType';
import SelectionState from 'state/selections/SelectionState';
import { selectDefinitions, selectFetchingData, selectFetchingTESbsData } from 'state/trackingError/selectors';
import { selectSideBySideValue } from "state/selections/selectors";

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const fetchingAbsSbsData = useSelector(
    selectFetchingTESbsData(SummaryType.ABSOLUTE)
  );
  const fetchingRelSbsData = useSelector(
    selectFetchingTESbsData(SummaryType.RELATIVE)
  );

  const sideBySideValue = useSelector(
    selectSideBySideValue(SelectionState.COMMITTED)
  );
  const dispatch = useDispatch();

  return React.useMemo(() => {
    return definitions.reduce((columnDefs, definition) => {
      const { factor, covarianceType, scaleType, calcType, key } = definition;
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      }
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `Tracking Error Acct ${scaleType === ScaleType.Contribution ? `` : ``} ${titleCase(factor)} ${titleCase(covarianceType)}`;
          columnDef.loading = fetchingAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `Tracking Error Rel ${scaleType === ScaleType.Contribution ? `` : ``} ${titleCase(factor)} ${titleCase(covarianceType)}`;
          columnDef.loading = fetchingRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `Tracking Error Bench ${scaleType === ScaleType.Contribution ? `` : ``} ${titleCase(factor)} ${titleCase(covarianceType)}`;
          columnDef.loading = fetchingAbsData;
          break;
        default:
          throw Error('Unknown calc type: ' + calcType);
      }

      columnDefs.push(columnDef);
      if (sideBySideValue) {
        const sbsColDef = {
          ...columnDef,
          headerName: columnDef.headerName + " - scenario",
          colId: columnDef.colId + " - scenario",
          field: columnDef.field + " - scenario",
          X_sbs: true,
          X_originalColId: key,
          X_backgroundColor: "#fffb95",
        };
        switch (calcType) {
          case CalcType.Account:
            sbsColDef.loading = fetchingAbsSbsData;
            break;
          case CalcType.Relative:
            sbsColDef.loading = fetchingRelSbsData;
            break;
          case CalcType.Benchmark:
            sbsColDef.loading = fetchingAbsSbsData;
            break;
          default:
            throw Error('Unknown calc type: ' + calcType);
        }


        columnDefs.push(sbsColDef);
      }
      return columnDefs;
    }, []);
  }, [dispatch, definitions, fetchingAbsData, fetchingRelData, sideBySideValue, fetchingAbsSbsData, fetchingRelSbsData]);
}
